import React, { Component } from "react";
import "./profile.scss";
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";
import Button from "devextreme-react/button";
import { Popup } from "devextreme-react/popup";
import TextBox from "devextreme-react/text-box";
import ValidationSummary from "devextreme-react/validation-summary";
import {
  Validator,
  RequiredRule,
  CompareRule,
} from "devextreme-react/validator";
import ScrollView from "devextreme-react/scroll-view";
import apiAxios from "../../api-axios";

import notify from "devextreme/ui/notify";
import ShowError from "../../AppServices";
const userInfo = JSON.parse(localStorage.getItem("User_Info"));
export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      senha: "",
      novaSenha: "",
      popupVisivel: false,
    };
    this.compararSenhas = this.compararSenhas.bind(this);
    this.passwordComparison = this.passwordComparison.bind(this);
    this.onPasswordChanged = this.onPasswordChanged.bind(this);
    this.onSenhaChanged = this.onSenhaChanged.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  compararSenhas() {
    return this.state.senha;
  }

  passwordComparison() {
    return this.state.novaSenha;
  }

  onSenhaChanged(e) {
    this.setState({
      senha: e.value,
    });
  }

  onPasswordChanged(e) {
    this.setState({
      novaSenha: e.value,
    });
  }

  onFormSubmit(e) {
    e.preventDefault();
    const formData = new FormData();
    //formData.append("senha", this.state.senha);
    //formData.append("novaSenha", this.state.novaSenha);
    let config = { headers: { "Content-Type": "multipart/form-data" } };
    apiAxios
      .put(`usuarios/senha/${userInfo.usuarioId}`, {
        senha: this.state.senha,
        novaSenha: this.state.novaSenha,
      })
      .then((response) => {
        if (response.status === 200) {
          notify("Senha alterada com sucesso", "success");
          this.setState({ popupVisivel: false });
        }
      })
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  render() {
    return (
      <React.Fragment>
        {/* <div
          className={"content-block dx-card responsive-paddings"}
          style={{ display: "none" }}
        >
          <div className={"form-avatar"}>
            <img
              alt={""}
              src={`https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/${employee.Picture}`}
            />
          </div>
          <span>{this.state.notes}</span>
        </div> */}

        <div className={"content-block dx-card responsive-paddings"}>
          <h2>Perfil de usuário</h2>
          <Form
            id={"form"}
            formData={userInfo}
            readOnly={true}
            labelLocation={"top"}
          >
            <GroupItem>
              <SimpleItem dataField={"nome"} />
              <SimpleItem dataField={"login"} />
              <SimpleItem dataField={"perfil"} />
              <SimpleItem dataField={"subPerfil"} />
            </GroupItem>
          </Form>
          <br />
          <br />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              text={"Mudar Senha"}
              width={120}
              type={"default"}
              onClick={() => this.setState({ popupVisivel: true })}
            />
          </div>
        </div>
        <Popup
          visible={this.state.popupVisivel}
          onHiding={() => this.setState({ popupVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showTitle={true}
          title="Tocar senha"
          width={"30%"}
          height={"60%"}
        >
          <ScrollView showScrollbar={"onScroll"}>
            <form action="your-action" onSubmit={this.onFormSubmit}>
              <div className="dx-fieldset">
                <div
                  className="dx-field"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <div className="dx-field-label">Senha Atual</div>
                  <div className="dx-field-value" style={{ width: "100%" }}>
                    <TextBox
                      mode="password"
                      value={this.state.senha}
                      onValueChanged={this.onSenhaChanged}
                    >
                      <Validator>
                        <RequiredRule message="É obrigatório digitar a senha!" />
                      </Validator>
                    </TextBox>
                  </div>
                </div>
                <div
                  className="dx-field"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <div className="dx-field-label">Nova Senha</div>
                  <div className="dx-field-value" style={{ width: "100%" }}>
                    <TextBox
                      mode="password"
                      value={this.state.novaSenha}
                      onValueChanged={this.onPasswordChanged}
                    >
                      <Validator>
                        <RequiredRule message="É obrigatório digitar a nova senha!" />
                        <CompareRule
                          message="A Nova Senha e a Senha Atual não podem ser iguais!"
                          comparisonType={"!="}
                          comparisonTarget={this.compararSenhas}
                        />
                      </Validator>
                    </TextBox>
                  </div>
                </div>
                <div
                  className="dx-field"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <div className="dx-field-label">Confirmar Senha</div>
                  <div className="dx-field-value" style={{ width: "100%" }}>
                    <TextBox mode="password">
                      <Validator>
                        <RequiredRule message="É obrigatório confirmar a senha!" />
                        <CompareRule
                          message="A Nova Senha e Confirmar Senha não conferem!"
                          comparisonTarget={this.passwordComparison}
                        />
                      </Validator>
                    </TextBox>
                  </div>
                </div>
              </div>
              <br />
              <ValidationSummary id="summary"></ValidationSummary>
              <br />
              <div
                className="dx-fieldset"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Button
                  id="button"
                  text="Registrar Senha"
                  type="success"
                  width={120}
                  useSubmitBehavior={true}
                />
              </div>
            </form>
          </ScrollView>
        </Popup>
      </React.Fragment>
    );
  }
}
